/** 前端操作符 → 后端操作符映射表（参照 API 接口文档 r2.md 第 6 节） */
export const EVENT_PARAM_OPERATOR_MAP: Record<string, string> = {
  include: 'in',
  exclude: 'not_in',
  greater: 'gt',
  greaterOrEqual: 'gte',
  less: 'lt',
  lessOrEqual: 'lte',
  equal: 'eq',
  notEqual: 'neq',
  between: 'between',
  contains: 'contains',
  notContains: 'not_contains',
  startsWith: 'starts_with',
  endsWith: 'ends_with',
  in: 'in',
  notIn: 'not_in',
};
